
import Swiper from 'https://unpkg.com/swiper@8/swiper-bundle.esm.browser.min.js';

class BannerHome
{
	Carrosel()
	{
		const TitleCarrossel = $('#BannerHomeSwiper .swiper-slide');
		const swiperNavControlls =
		{
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		};
		const swiperAutoplay = 
		{
			delay: 8000,
		}

		const swiper = new Swiper('#BannerHomeSwiper', 
		{
			slidesPerView: 1,
			spaceBetween: 0,
			speed: 1000,
			simulateTouch:TitleCarrossel.length > 1 ? true : false,
			loop: TitleCarrossel.length > 1 ? true : false,
			autoHeight: false,
			autoplay:TitleCarrossel.length > 1 ? swiperAutoplay : false,
			disableOnInteraction: false,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: 
			{
				0: {
					autoHeight: true,
				},
				992: {
					autoHeight: false,
				}
			}
		});
	}

	init(options)
	{
		const self = this;

		if ($("#CCBannerHome").length > 0)
    	{
			self.Carrosel();
		}

		$(window).resize(function()
		{
			if ($("#CCBannerHome").length > 0)
			{
				self.Carrosel();
			}
		});
	}
}

export default BannerHome;